import { useMutation } from '@tanstack/react-query';

export type CandidateEndpointBulkCopyToCandidatesPostRequest = {
  candidateProfileId: number;
  jobPostEndpointIds: number[];
  targetCandidateProfileIds: number[];
};

export default function usePostCandidateEndpointBulkCopyToCandidates() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      candidateProfileId,
      jobPostEndpointIds,
      targetCandidateProfileIds,
    }: CandidateEndpointBulkCopyToCandidatesPostRequest) => {
      const response = await fetch(
        `/agent/api/candidate_endpoints/${candidateProfileId}/bulk_copy_to_candidates`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({
            job_post_endpoint_ids: jobPostEndpointIds,
            target_candidate_profile_ids: targetCandidateProfileIds,
          }),
        }
      );
      if (!response.ok) {
        throw new Error('Failed to copy job post endpoints');
      }
      return response.json();
    },
  });
}
